import script from "./Csp.vue?vue&type=script&setup=true&lang=js"
export * from "./Csp.vue?vue&type=script&setup=true&lang=js"

import "./Csp.vue?vue&type=style&index=0&id=2d60b0d2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d60b0d2"]])

export default __exports__